<template>
  <section
    :class="[
      'festival-year__banner',
      { 'festival-year__banner--short': !isFestivalYearHomepage },
    ]"
    :style="{ backgroundImage: `url(${festivalYearBanner})` }"
  ></section>
</template>

<script>
import festivalYearDesktopBanner from '@/assets/images/banner_festival_1224.png';
import festivalYearMobileBanner from '@/assets/images/banner_festival_mobile.png';

export default {
  name: 'FestivalYearBanner',
  props: {
    isFestivalYearHomepage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    festivalYearBanner() {
      return this.windowWidth > 375
        ? festivalYearDesktopBanner
        : festivalYearMobileBanner;
    },
    windowWidth() {
      return this.$store.getters.windowWidth;
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.festival-year {
  &__banner {
    position: relative;
    background-position: center center;
    background-size: cover;
    width: 100%;
    height: 212px;
    top: 18px;

    @include for-tablet-horizontal {
      height: 320px;
    }

    &::before {
      content: "";
      position: absolute;
      background: url("../assets/images/header/divider_festival.png");
      background-size: cover;
      width: 100%;
      height: 15px;
      bottom: -15px;
    }

    &--short {
      height: 213px;

      @include for-tablet-horizontal {
        height: 320px;
      }
    }
  }
}
</style>
